module.exports = __webpack_public_path__ + "img/Group 4603@2x.6fe4195e.png";